import { render } from "./RegisterSuccess.vue?vue&type=template&id=2856fcc0&scoped=true"
import script from "./RegisterSuccess.vue?vue&type=script&lang=js"
export * from "./RegisterSuccess.vue?vue&type=script&lang=js"

import "@/assets/css/Header.css?vue&type=style&index=0&id=2856fcc0&scoped=true&lang=css&external"
import "./RegisterSuccess.vue?vue&type=style&index=1&id=2856fcc0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2856fcc0"]])

export default __exports__